'use client'

import Notice from '@/app/notice/_components/Notice'
import { useScrollTracking } from '@/hooks/useScrollTracking'

const NoticePage = () => {
  useScrollTracking()
  
  return <Notice />
}

export default NoticePage
